import Vue from 'vue'
import Router from 'vue-router'


import PPTest          from './views/pptest.vue';


// Default
//import Home           from './views/home.vue'
import Home           from './views/home_old.vue'
import HomeOld        from './views/home_old.vue'
import HomeTest       from './views/home_test.vue'
import GetStarted     from './views/get_started.vue'

// Static Pages
import FAQ            from './views/static/faq.vue';
import Pricing        from './views/static/pricing.vue';

// Footer Pages
import Privacy        from './views/static/privacy.vue';
import About          from './views/static/about.vue';
import Contact        from './views/static/contact.vue';
import Terms          from './views/static/terms.vue';
import Testimonials   from './views/static/testimonials.vue';

// Auth
import Login          from './views/auth/login.vue';
import Register       from './views/auth/register.vue';
import ForgotPassword from './views/auth/forgot.vue';
import ResetPassword  from './views/auth/reset.vue';
//import Confirmation   from './views/auth/confirmation/link.vue';
//import Unsubscribe    from './views/auth/unsubscribe.vue';

// Email Upload Order
// Default
import Order          from './views/order.vue'
import OrderComplete  from './views/order_complete.vue'

import Emails         from './views/emails.vue'
import Files          from './views/files.vue'
import Settings       from './views/settings.vue'

import UploadStart    from './views/upload_start.vue'


// QR Code Landing page
import QrLanding      from './views/qr_landing.vue'

// DDNA Landing page
import DdnaLanding    from './views/ddna_landing.vue'


//404
import NotFound       from "./views/static/404.vue";





Vue.use(Router)

export default new Router({
	mode: "history",
	base: process.env.BASE_URL,
	routes: [
		{
			path:      '/home-old',
			name:      'home_old',
			component: HomeOld
		},

		{
			path:      '/simon',
			name:      'home_old',
			component: HomeOld
		},

		{
			path:      '/',
			name:      'home',
			component: Home
		},

		{
			path:      '/get_started',
			name:      'get_started',
			component: GetStarted
		},
        

		{
			path:      '/upload_start',
			name:      'upload_start',
			component: UploadStart
		},

        {
			path:      '/order/:reference',
			name:      'order',
			component: Order
		},

		{
			path:      '/order_complete/:reference',
			name:      'order_complete',
			component: OrderComplete
		},

		/*
		{
			path: '/pptest',
			name: 'pptest',
			component: PPTest
		},
		*/

		{
			path:      '/login',
			name:      'login',
			component: Login
		},
		{
			path:      '/register',
			name:      'register',
			component: Register
		},
		{
			path:      '/forgot',
			name:      'forgot',
			component: ForgotPassword
		},
		{
			path:      '/reset/:token_code',
			name:      'reset',
			component: ResetPassword
		},
		
		{
			path:      '/emails',
			name:      'emails',
			component: Emails
		},
		{
			path:      '/files',
			name:      'files',
			component: Files
		},

		{
			path:      '/settings',
			name:      'settings',
			component: Settings
		},

		{
			path:      '/file/:ddna',
			name:      'ddna_landing',
			component: DdnaLanding
		},

        /*
		{
			path:      '/qr/:ddna',
			name:      'qr_landing',
			component: QrLanding
		},
        */
		
		/*
		{
			path: '/confirmation/:token_code',
			name: 'Confirmation',
			component: Confirmation
		},
		{
			path: '/unsubscribe/:token_code',
			name: 'Unsubscribe',
			component: Unsubscribe
		},
		{
			path: '/confirm_withdrawal/:token_code',
			name: 'WithdrawalConfirmation',
			component: ConfirmWithdrawal
		},
		*/

		
		// **
		// ** Static Pages
		// **
		{
			path:      '/faq',
			name:      'faq',
			component: FAQ
		},
		{
			path:      '/pricing',
			name:      'pricing',
			component: Pricing
		},
		{
			path:      '/testimonials',
			name:      'testimonials',
			component: Testimonials
		},

		{
			path:      '/privacy',
			name:      'privacy',
			component: Privacy
		},
		{
			path:      '/about',
			name:      'about',
			component: About
		},
		{
			path:      '/contact',
			name:      'contact',
			component: Contact
		},
		{
			path:      '/terms',
			name:      'terms',
			component: Terms
		},

	
		// **
		// ** Catch-all (404)
		// **
		{
			path: '*',
			//component:NotFound
			name: "catchall",
			component: NotFound
		}
		
	]
})
